import React, { Suspense, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { actions } from 'slices/app.slice'
import { path } from 'utils/const'
import Fallback from 'components/Fallback'
import Spinner from 'components/Spinner'
import PendingApproval from './pages/pendingApproval/PendingApproval'
import Consultation from './pages/consultation/Consultation'
import ActiveConsultationPage from './pages/activeConsultation/ActiveConsultationPage'
import PastConsultationPage from './pages/pastConsultation/PastConsultationPage'
import ReviewPrescriptions from './pages/prescriptions/ReviewPrescriptions'
import PastConsultationDetail from './pages/pastConsultation/PastConsultationDetail'
import ViewPerscription from './pages/prescriptions/ViewPerscription'
import ChatModule from './pages/chatModule/ChatModule'
import ProfileView from './pages/Profile/ProfileView'
import DoctorInformation from './pages/Profile/DoctorInformation'
import SendMail from './pages/prescriptions/SendMail'
import ResetPassword from './pages/auth/ResetPassword'
import LabRequistionPage from './pages/labRequisitions/LabRequisitionPage'
import LabTracking from './pages/labRequisitions/LabTracking'
import LabEdits from './pages/labRequisitions/LabEdits'
import SoapNotes from './pages/labRequisitions/SoapNotes'
import ViewSoapNotes from './pages/labRequisitions/ViewSoapNotes'
import ViewResults from './pages/labRequisitions/ViewResults'
import WriteSoapNotes from './pages/labRequisitions/WriteSoapNotes'
import Results from './pages/labRequisitions/Results'
import StartChat from './pages/labRequisitions/Chat/StartChat'
import ViewUpdates from './pages/labRequisitions/ViewUpdates'


const Auth = React.lazy(() => import('./pages/auth'))
const Dashboard = React.lazy(() => import('./pages/dashboard'))

function Router() {
  const dispatch = useDispatch()
  const { checked, loggedIn } = useSelector((state) => state.app)

  useEffect(() => {
    console.log('Checking authentication status...')
    dispatch(actions.authenticate())
  }, [])

  if (!checked) {
    return (
      <div className="app-loader-container">
        <Spinner size="4rem" color="white" isLoading />
      </div>
    )
  }

  return (
    <div>
      <BrowserRouter>
        <Suspense fallback={<Fallback />}>
          {!loggedIn ? (
            <Routes>
              <Route path="*" element={<Auth />} />
              <Route path="/auth/*" element={<Auth />} />

              {/*
               <Navigate to="/" element={<Auth />} />
*/}
            </Routes>
          ) : (
            <Routes>
              <Route path="*" element={<Dashboard />} />
              <Route path={path.dashboard} element={<Dashboard />} />
              <Route
                path={path.pendingapproval}
                element={<PendingApproval />}
              />
              <Route
                path={path.activeconsultationpage}
                element={<ActiveConsultationPage />}
              />
              <Route path={path.consultation} element={<Consultation />} />
              <Route
                path={path.reviewprescriptions}
                element={<ReviewPrescriptions />}
              />
              <Route
                path={path.pastconsultationpage}
                element={<PastConsultationPage />}
              />
              <Route
                path={path.PastConsultationDetail}
                element={<PastConsultationDetail />}
              />
              <Route
                path={path.labrequistionpage}
                element={<LabRequistionPage />}
              />
              <Route
                path={`${path.labtracking}/:chatID`}
                element={<LabTracking />}
              />
              <Route
                path={`${path.labedits}/:chatID`}
                element={<LabEdits />}
              />
              <Route
                path={`${path.soapnotes}/:chatID`}
                element={<SoapNotes />}
              />
              <Route
                path={`${path.viewsoapnotes}/:chatID`}
                element={<ViewSoapNotes />}
              />
              <Route
                path={`${path.writesoapnotes}/:chatID`}
                element={<WriteSoapNotes />}
              />
              <Route
                path={`${path.startchat}/:chatID`}
                element={

                  <StartChat />
                }
              />
              <Route
                path={path.viewprescription}
                element={<ViewPerscription />}
              />
              <Route
                path={`${path.viewresults}/:chatID`}
                element={<ViewResults />}
              />
              <Route
                path={`${path.viewupdates}/:chatID`}
                element={<ViewUpdates />}
              />
              <Route
                path={`${path.results}/:chatID/:resultID`}
                element={<Results />}
              />
              <Route path={path.ChatModule} element={<ChatModule />} />
              <Route path={path.profileview} element={<ProfileView />} />
              <Route
                path={path.doctorinformation}
                element={<DoctorInformation />}
              />
              <Route path={path.sendmail} element={<SendMail />} />
              <Route path={path.changepassword} element={<ResetPassword />} />
              {/* <Navigate to={path.dashboard} /> */}
            </Routes>
          )}
        </Suspense>
      </BrowserRouter>
    </div>
  )
}

export default Router
